import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, ElementRef, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { mksMITOCWData } from '../../shared/json/mksMITOCWData';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from './../../../environments/environment';
import { Subscription, forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface Sources {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
    includeSubTopic: { [key: string]: boolean };
}
interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: [];
    subtopics: [];
    sources: Array<any>;
    sourceParams: any;
    sourcesSubTopic: any;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    skipRelevance: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
}
@Component({
    selector: 'app-gyan-knowledge-store',
    templateUrl: './gyan-knowledge-store.component.html',
    styleUrls: ['./gyan-knowledge-store.component.scss'],
})
export class GyanKnowledgeStoreComponent implements OnInit {
    gksLibrary: any;
    checkedListGKS: any;
    isMobile = false;
    masterSelected: any;

    apiResponse: any;
    form: FormGroup;
    selectedGyanKnowledgeStore: any = null;
    isLoadingTags: boolean = false;
    checkedRepoIds: Array<string> = [];
    minDateTo: string = '';
    maxDateFrom: string = '';
    removedFieldKey: string | null = null; // Property to track the removed field key
    maxVisibleBadges = 2;
    optionCtrl = new FormControl();
    private modalRef: NgbModalRef | undefined;
    mksFlag: boolean = false;
    // Static Data
    mksMITOCWData = mksMITOCWData;
    showPKSPermissionAccess = false;
    //isIncludeSubtopic = true;
    topicOutline: Topic | any;
    @Output() sendCheckedListGKS = new EventEmitter<void>();
    @Input() gksLevel: string = 'gyanLevel';
    @Input() topic!: any;
    @Input() flagFromSubmitGyan: boolean = true;
    getTemplateSubsSources: Subscription | undefined;
    getTemplateSourcesSubTopics: Subscription | undefined;
    templateLoaded: Subscription | undefined;
    managePKS: boolean = false;

    constructor(
        private toastr: ToastrService,
        private submitgyanService: SubmitgyanService,
        private fb: FormBuilder,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private eRef: ElementRef,
        private authservice: AuthService,
        private commonservice: CommonServiceService,
    ) {
        this.form = this.fb.group({
            fields: this.fb.array([]),
            isIncludeSubtopic: [true],
        });

        this.templateLoaded = this.commonservice.templateLoaded$.subscribe((data) => {
            if (data) {
                this.managePKS = true;
            }
        });
    }

    ngOnInit() {
        //    console.log('pageloaded');
        this.checkWidth();
        if (this.flagFromSubmitGyan) this.checkAndAddSourcesToLocalStorage();

        this.callKnowledgeStore();
        this.getAccessPermission();
        // setTimeout(() => {
        //     this.callingSubjects();
        // }, 500);
    }

    callingSubjects() {
        //this subject is for main sources
        this.getTemplateSubsSources = this.commonservice.templateDataSubjectForSources$.subscribe((sources: any) => {
            //console.log('sources---', Object.keys(sources).length);
            if (sources !== null && Object.keys(sources).length > 0) {
                console.log('sources is', sources);
                console.log('this.gksLibrary is', this.gksLibrary);
                const localStorageKey = 'gyanKnowledgeStore';

                this.convertDataToFormData(localStorageKey, sources.knowledgeStoreIds, sources.repoIds).subscribe((convertedData) => {
                    console.log('Transformed Data:', convertedData);
                    // Store the transformed data in localStorage
                    localStorage.setItem(localStorageKey, JSON.stringify(convertedData));
                    // Perform additional actions. such as retrieving sources from localStorage
                    this.getSourcesFromLocalStorage();
                });
            }
        });

        //this subject is for subtopic sources
        this.getTemplateSourcesSubTopics = this.commonservice.templateDataSubjectForTopicOutline$.subscribe((topicOutline: any) => {
            if (topicOutline) {
                console.log('topicOutline-fromsubject', topicOutline);
                const localStorageKeyGK = 'subtopicSource_gyanKnowledgeStore';
                //this.processAndStoreSubtopicsWithApi(topicOutline, localStorageKeyGK);

                // getting data from topic and subtopics
                const flatData = this.flattenTopics(topicOutline);
                console.log('Flattened Data:', flatData);
                //debugger;
                // transforming data
                this.transformKnowledgeStore(flatData).subscribe((transformedData) => {
                    console.log('Transformed Data:', transformedData);

                    this.rebuildAndStore(transformedData, localStorageKeyGK);
                });
            }
        });
    }

    flattenTopics(topic: any, flatData: any = {}): any {
        if (!flatData[topic.id]) {
            //flatData[topic.id] = topic.sourcesSubTopic?.knowledgeStoreIds || {};
            flatData[topic.id] = {
                knowledgeStoreIds: topic.sourcesSubTopic?.knowledgeStoreIds || {},
                repoIds: topic.sourcesSubTopic?.repoIds || {},
            };
        }

        // Include repoIds if they exist and match the condition
        // if (topic.sourcesSubTopic?.repoIds) {
        //     Object.keys(topic.sourcesSubTopic.repoIds).forEach((repoId) => {
        //         // Check if the repoId exists in gksLibrary and is checked
        //         const matchedRepo = this.gksLibrary?.find((gks: any) => gks.id === repoId && gks.checked);

        //         if (matchedRepo) {
        //             flatData[topic.id].repoIds[repoId] = topic.sourcesSubTopic.repoIds[repoId];
        //         }
        //     });
        // }

        if (Array.isArray(topic.subtopics)) {
            topic.subtopics.forEach((subtopic: any) => this.flattenTopics(subtopic, flatData));
        }

        return flatData;
    }

    transformKnowledgeStore(flatData: any): Observable<any> {
        const transformedData: any = {};
        const apiCalls: Array<Observable<any>> = [];

        Object.keys(flatData).forEach((topicId) => {
            transformedData[topicId] = {};
            //console.log("flatData[topicId]", flatData[topicId]);
            Object.keys(flatData[topicId].knowledgeStoreIds).forEach((knowledgeStoreId) => {
                const dynamicData = flatData[topicId].knowledgeStoreIds[knowledgeStoreId];
                console.log('dynamicData', dynamicData);
                const apiCall = this.submitgyanService.getKnowledgeStoreTags(knowledgeStoreId).pipe(
                    map((response: any) => {
                        const apiResponse = response.tags || [];

                        const fields = Object.keys(dynamicData || {}).map((fieldKey) => {
                            const fieldData = dynamicData[fieldKey];
                            let dateFieldFrom = '';
                            let dateFieldTo = '';

                            // handling Date fields
                            if (fieldData.DT === 'Date' && fieldData.V?.length > 0) {
                                dateFieldFrom = new Date(fieldData.V[0]).toISOString().split('T')[0];
                                dateFieldTo = new Date(fieldData.V[fieldData.V.length - 1]).toISOString().split('T')[0];
                            }

                            return {
                                key: fieldKey,
                                tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                dataType: fieldData.DT || '',
                                dateFieldFrom,
                                dateFieldTo,
                                optionCtrl: '',
                                filteredOptions: [],
                                showDropdown: !!fieldData.V,
                                selectedOptions: fieldData.V || [],
                                id: '',
                            };
                        });

                        // adding an empty field at the end
                        fields.push({
                            key: '',
                            tagValues: '',
                            dataType: '',
                            dateFieldFrom: '',
                            dateFieldTo: '',
                            optionCtrl: '',
                            filteredOptions: [],
                            showDropdown: false,
                            selectedOptions: [],
                            id: '',
                        });

                        transformedData[topicId][knowledgeStoreId] = {
                            apiResponse,
                            formData: {
                                fields,
                                isIncludeSubtopic: true,
                            },
                        };
                    }),
                );

                apiCalls.push(apiCall);
            });

            //this is for repo id - special case for MIT OCW
            console.log('flatData repoIds testing', flatData);
            Object.keys(flatData[topicId].repoIds).forEach((knowledgeStoreId) => {
                const dynamicData = flatData[topicId].repoIds[knowledgeStoreId];

                let sitename = '';
                console.log('this.gksLibrary- ', this.gksLibrary);
                this.gksLibrary.map((item: { id: string; siteName: string }) => {
                    if (item.id === knowledgeStoreId) {
                        sitename = item.siteName;
                    }
                });
                console.log(sitename);
                // const apiCall = this.submitgyanService.getRepoTags(siteName).pipe(
                const apiCall = this.submitgyanService.getRepoTags(sitename).pipe(
                    map((response: any) => {
                        const apiResponse = response || [];
                        console.log('apiResponse', apiResponse);
                        const fields = Object.keys(dynamicData || {}).map((fieldKey) => {
                            const fieldData = dynamicData[fieldKey];
                            let dateFieldFrom = '';
                            let dateFieldTo = '';

                            // handling Date fields
                            if ((fieldData.DT === 'date' || fieldData.DT === 'datetime') && fieldData.V?.length > 0) {
                                dateFieldFrom = new Date(fieldData.V[0]).toISOString().split('T')[0];
                                dateFieldTo = new Date(fieldData.V[fieldData.V.length - 1]).toISOString().split('T')[0];
                            }

                            // Map additional data into `key`
                            const matchingTag = apiResponse.find((tag: any) => tag.id === fieldKey) || {};
                            const additionalField: any = {
                                id: matchingTag.id || '',
                                tagName: matchingTag.tagName || '',
                                idWithoutSite: matchingTag.idWithoutSite || '',
                                dataType: matchingTag.dataType || fieldData.DT || '',
                            };

                            return {
                                key: additionalField,
                                tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                dataType: fieldData.DT || '',
                                dateFieldFrom,
                                dateFieldTo,
                                optionCtrl: '',
                                filteredOptions: [],
                                showDropdown: !!fieldData.V,
                                selectedOptions: fieldData.V || [],
                                id: '',
                            };
                        });

                        // adding an empty field at the end
                        fields.push({
                            key: '',
                            tagValues: '',
                            dataType: '',
                            dateFieldFrom: '',
                            dateFieldTo: '',
                            optionCtrl: '',
                            filteredOptions: [],
                            showDropdown: false,
                            selectedOptions: [],
                            id: '',
                        });

                        transformedData[topicId][knowledgeStoreId] = {
                            apiResponse,
                            formData: {
                                fields,
                                isIncludeSubtopic: true,
                            },
                        };
                        console.log('transformedData MIT', transformedData[topicId][knowledgeStoreId]);
                    }),
                );

                apiCalls.push(apiCall);
            });
        });
        return forkJoin(apiCalls).pipe(map(() => transformedData));
    }

    rebuildAndStore(transformedData: any, localStorageKey: string): void {
        localStorage.setItem(localStorageKey, JSON.stringify(transformedData));
        console.log('Final Data in LocalStorage:', transformedData);
    }

    // private transformAndStoreData(consolidatedData: any, localStorageKey: string): void {
    //     const apiCalls: Observable<any>[] = [];
    //     const apiMapping: { [key: string]: any } = {};

    //     // API calls for all knowledgeStoreIds
    //     Object.keys(consolidatedData).forEach((topicId) => {
    //       Object.keys(consolidatedData[topicId]).forEach((knowledgeStoreId) => {
    //         const dynamicData = consolidatedData[topicId][knowledgeStoreId]?.dynamicData;

    //         apiMapping[knowledgeStoreId] = { topicId, dynamicData };

    //         const apiCall = this.submitgyanService.getKnowledgeStoreTags(knowledgeStoreId).pipe(
    //           map((response: any) => ({
    //             knowledgeStoreId,
    //             apiResponse: response.tags || [],
    //           }))
    //         );

    //         apiCalls.push(apiCall);
    //       });
    //     });

    //     // Process API responses
    //     forkJoin(apiCalls).subscribe((results) => {
    //       results.forEach((result) => {
    //         const { knowledgeStoreId, apiResponse } = result;
    //         const { topicId, dynamicData } = apiMapping[knowledgeStoreId];

    //         // Ensure topic exists in consolidatedData
    //         if (!consolidatedData[topicId]) {
    //           consolidatedData[topicId] = {};
    //         }

    //         // Transform dynamicData into fields
    //         const fields = Object.keys(dynamicData || {}).map((fieldKey) => {
    //           const fieldData = dynamicData[fieldKey];
    //           let dateFieldFrom = "";
    //           let dateFieldTo = "";

    //           // Handle date type fields
    //           if (fieldData.DT === "Date" && fieldData.V?.length > 0) {
    //             dateFieldFrom = new Date(fieldData.V[0]).toISOString().split("T")[0];
    //             dateFieldTo = new Date(fieldData.V[fieldData.V.length - 1])
    //               .toISOString()
    //               .split("T")[0];
    //           }

    //           return {
    //             key: fieldKey,
    //             tagValues: fieldData.V ? fieldData.V.join(", ") : "",
    //             dataType: fieldData.DT || "",
    //             dateFieldFrom,
    //             dateFieldTo,
    //             optionCtrl: "",
    //             filteredOptions: [],
    //             showDropdown: !!fieldData.V,
    //             selectedOptions: fieldData.V || [],
    //             id: "",
    //           };
    //         });

    //         // Add an empty field at the end
    //         fields.push({
    //           key: "",
    //           tagValues: "",
    //           dataType: "",
    //           dateFieldFrom: "",
    //           dateFieldTo: "",
    //           optionCtrl: "",
    //           filteredOptions: [],
    //           showDropdown: false,
    //           selectedOptions: [],
    //           id: "",
    //         });

    //         // Directly overwrite dynamicData
    //         consolidatedData[topicId][knowledgeStoreId] = {
    //           apiResponse,
    //           formData: {
    //             fields,
    //             isIncludeSubtopic: true,
    //           },
    //         };

    //         console.log(`Transformed ${knowledgeStoreId} for Topic ${topicId}:`, {
    //           apiResponse,
    //           formData: {
    //             fields,
    //           },
    //         });
    //       });

    //       //final data to localStorage
    //       localStorage.setItem(localStorageKey, JSON.stringify(consolidatedData));
    //       console.log("Final Data in LocalStorage:", consolidatedData);
    //     });
    // }

    getAccessPermission() {
        this.showPKSPermissionAccess = this.authservice.getAccessList('ShowPKS');
    }

    checkAndAddSourcesToLocalStorage(): void {
        const localStorageKey = 'sources';
        if (!localStorage.getItem(localStorageKey)) {
            // if not exists create an empty Sources object
            const sources: Sources = {
                repoIds: {},
                repoAvailable: false,
                knowledgeStoreIds: {},
                webAvailable: false,
                favouriteWebsites: [],
                dispreferredWebsites: [],
                includeSubTopic: {},
            };
            localStorage.setItem(localStorageKey, JSON.stringify(sources));
            console.log('sources added to localStorage:', sources);
        } else {
            console.log('sources already exist in localStorage.');
        }
    }

    callKnowledgeStore() {
        this.submitgyanService.getKnowledgeStore().subscribe({
            next: (response: any) => {
                console.log('the list is', JSON.stringify(response));
                //this.gksLibrary = response.gyanKnowledgeStoreDetails;
                const apiData = response.gyanKnowledgeStoreDetails;
                console.log('gksLibrary', this.gksLibrary);
                apiData.forEach((source: { id: string; name: string; siteName: string; checked: boolean }) => {
                    source.siteName = '';
                    //this.gksLibrary.forEach((source: { id: string; name: string; checked: boolean }) => {
                    if (this.gksLevel == 'gyanLevel') {
                        if (source.name === 'Primary Knowledge Store') {
                            const sources = this.getSourcesFromLocalStorage();
                            source.checked = this.managePKS ? !!sources?.knowledgeStoreIds?.[source.id] : true;
                            if (this.showPKSPermissionAccess) {
                                this.updateSourcesWithCheckbox(source.id, source.checked);
                            }
                            //this.updateSourcesWithCheckbox(source.id, source.checked);
                        } else {
                            source.checked = false;
                        }
                    }
                });
                const envmksMITOCWData = (mksMITOCWData.find((item) => item.env === environment.type)?.data || []).map((item) => ({
                    ...item,
                    checked: false,
                }));
                this.gksLibrary = [...apiData, ...envmksMITOCWData];

                if (!this.showPKSPermissionAccess) {
                    this.gksLibrary = this.gksLibrary.filter((item: { id: string }) => item.id !== '6c8c9bb8-c587-33bb-9f36-d395d20f9251+03ac025a-6eef-387f-9912-269b1478ad8c');
                }
                console.log('GKSLibrary.....', this.gksLibrary);
                this.checkedListGKS = this.gksLibrary.filter((itm: any) => itm.checked === true);
                if (this.flagFromSubmitGyan) this.callingSubjects();

                if (this.topic) {
                    const includeSubTopic = this.topic.sourcesSubTopic.includeSubTopic;
                    console.log('gks', includeSubTopic);
                    this.gksLibrary = this.gksLibrary.map((item: any) => ({
                        ...item,
                        checked: item.id in includeSubTopic,
                    }));
                }
                if (this.gksLevel == 'gyanLevel') {
                    const sources = this.getSourcesFromLocalStorage();
                    console.log('sources', sources);
                    const storedIds = Object.keys(sources?.knowledgeStoreIds || {});

                    this.gksLibrary = this.gksLibrary.map((item: any) => ({
                        ...item,
                        checked: storedIds.includes(item.id),
                    }));
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);
            },
            complete: () => {},
        });
    }

    //converting date back to original
    formatDate(dateString: string): string {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    }

    //converting data for sources in localstorage
    convertDataToFormData(localStorageKey: any, inputData: any, inputRepoData: any) {
        console.log('inputData', inputData);
        console.log('inputRepoData', inputRepoData);

        const apiCalls: Array<Observable<any>> = [];
        const convertedData: any = {};
        inputData = inputData ?? {};
        // Iterate over inputData keys
        Object.keys(inputData).forEach((key) => {
            const dynamicData = inputData[key];
            console.log('Processing Key:', key, 'Dynamic Data:', dynamicData);

            console.log('this.gksLibrary', this.gksLibrary);
            this.gksLibrary = this.gksLibrary?.map((item: { id: string; siteName: string }) => {
                if (item.id === key) {
                    return { ...item, checked: true };
                }
                return item;
            });
            // Make API call for this key
            const apiCall = this.submitgyanService.getKnowledgeStoreTags(key).pipe(
                map((response: any) => {
                    const apiResponse = response.tags; // Assuming the response contains `tags`

                    const fields = apiResponse
                        .filter((tag: any) => dynamicData && dynamicData[tag.tagName])
                        .map((matchingTag: any) => {
                            const fieldData = dynamicData[matchingTag.tagName];

                            // Handle Date Type: Split into dateFieldFrom and dateFieldTo
                            let dateFieldFrom = '';
                            let dateFieldTo = '';
                            if (fieldData.DT === 'Date' && fieldData.V?.length > 0) {
                                dateFieldFrom = this.formatDate(fieldData.V[0]) || '';
                                dateFieldTo = this.formatDate(fieldData.V[fieldData.V.length - 1]) || '';
                            }

                            return {
                                key: matchingTag.tagName,
                                tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                dataType: fieldData.DT || matchingTag.dataType || '',
                                dateFieldFrom: dateFieldFrom,
                                dateFieldTo: dateFieldTo,
                                optionCtrl: '',
                                filteredOptions: [],
                                showDropdown: !!fieldData.V,
                                selectedOptions: fieldData.V || [],
                                id: '',
                            };
                        });

                    // Add an empty field at the end
                    fields.push({
                        key: '',
                        tagValues: '',
                        dataType: '',
                        dateFieldFrom: '',
                        dateFieldTo: '',
                        optionCtrl: '',
                        filteredOptions: [],
                        showDropdown: false,
                        selectedOptions: [],
                        id: '',
                    });

                    // Assign the final transformed data
                    convertedData[key] = {
                        apiResponse: apiResponse,
                        formData: {
                            fields:
                                fields.length > 1
                                    ? fields
                                    : [
                                          {
                                              key: '',
                                              tagValues: '',
                                              dataType: '',
                                              dateFieldFrom: '',
                                              dateFieldTo: '',
                                              optionCtrl: '',
                                              filteredOptions: [],
                                              showDropdown: false,
                                              selectedOptions: [],
                                              id: '',
                                          },
                                      ],
                            isIncludeSubtopic: true,
                        },
                    };
                }),
            );

            apiCalls.push(apiCall);
        });

        // Iterate over inputRepoData keys  -- for special case MIT OCW
        Object.keys(inputRepoData).forEach((key) => {
            const dynamicData = inputRepoData[key];
            console.log('Processing Key:', key, 'Dynamic Repo Data:', dynamicData);

            console.log('this.gksLibrary', this.gksLibrary);
            let sitename = '';
            this.gksLibrary = this.gksLibrary?.map((item: { id: string; siteName: string }) => {
                if (item.id === key) {
                    console.log('repoItem', item);
                    sitename = item.siteName;
                    return { ...item, checked: true };
                }
                return item;
            });
            console.log('siteName---', sitename);
            if (sitename !== '') {
                // Make API call for this key
                const apiCall = this.submitgyanService.getRepoTags(sitename).pipe(
                    map((response: any) => {
                        const apiResponse = response; // Assuming the response contains `tags`

                        const fields = apiResponse
                            .filter((tag: any) => dynamicData && dynamicData[tag.id])
                            .map((matchingTag: any) => {
                                const fieldData = dynamicData[matchingTag.id];

                                // Handle Date Type: Split into dateFieldFrom and dateFieldTo
                                let dateFieldFrom = '';
                                let dateFieldTo = '';
                                if ((fieldData.DT === 'datetime' || fieldData.DT === 'date') && fieldData.V?.length > 0) {
                                    dateFieldFrom = this.formatDate(fieldData.V[0]) || '';
                                    dateFieldTo = this.formatDate(fieldData.V[fieldData.V.length - 1]) || '';
                                }

                                //key for mks
                                const additionalField = {
                                    id: matchingTag.id || '',
                                    tagName: matchingTag.tagName || '',
                                    idWithoutSite: matchingTag.idWithoutSite || '',
                                    dataType: matchingTag.dataType || '',
                                };

                                return {
                                    key: additionalField,
                                    tagValues: fieldData.V ? fieldData.V.join(', ') : '',
                                    dataType: fieldData.DT || matchingTag.dataType || '',
                                    dateFieldFrom: dateFieldFrom,
                                    dateFieldTo: dateFieldTo,
                                    optionCtrl: '',
                                    filteredOptions: [],
                                    showDropdown: !!fieldData.V,
                                    selectedOptions: fieldData.V || [],
                                    id: '',
                                };
                            });

                        // Add an empty field at the end
                        fields.push({
                            key: '',
                            tagValues: '',
                            dataType: '',
                            dateFieldFrom: '',
                            dateFieldTo: '',
                            optionCtrl: '',
                            filteredOptions: [],
                            showDropdown: false,
                            selectedOptions: [],
                            id: '',
                        });

                        // Assign the final transformed data
                        convertedData[key] = {
                            apiResponse: apiResponse,
                            formData: {
                                fields:
                                    fields.length > 1
                                        ? fields
                                        : [
                                              {
                                                  key: '',
                                                  tagValues: '',
                                                  dataType: '',
                                                  dateFieldFrom: '',
                                                  dateFieldTo: '',
                                                  optionCtrl: '',
                                                  filteredOptions: [],
                                                  showDropdown: false,
                                                  selectedOptions: [],
                                                  id: '',
                                              },
                                          ],
                                isIncludeSubtopic: true,
                            },
                        };
                    }),
                );

                apiCalls.push(apiCall);
            }
        });

        // Wait for all API calls to complete
        return forkJoin(apiCalls).pipe(
            map(() => {
                // Store the transformed data in localStorage
                localStorage.setItem(localStorageKey, JSON.stringify(convertedData));
                return convertedData;
            }),
        );
    }

    isAllSelected(gyanKnowledgeStore: any, gyanId: string) {
        this.mksFlag = gyanKnowledgeStore.siteName !== '' ? true : false;
        this.masterSelected = this.gksLibrary.every(function (item: any) {
            return item.checked === true;
        });
        //this.getCheckedItemList();
        if (this.gksLevel == 'topicLevel') {
            if (gyanKnowledgeStore.checked) this.IncludeSubtopic(gyanId, true, false);
            else this.IncludeSubtopic(gyanId, true, true);
        }
        this.updateSourcesWithCheckbox(gyanId, gyanKnowledgeStore.checked);
    }

    /* eslint-disable sonarjs/cognitive-complexity */
    updateSourcesWithCheckbox(gyanId: string, ischecked: boolean) {
        if (this.gksLevel === 'topicLevel') {
            this.updateTopicOutlineSources(gyanId, ischecked);
            this.sendCheckedListGKS.emit();
            return;
        }
        const sources = this.getSourcesFromLocalStorage();
        if (!ischecked) {
            if (!sources.knowledgeStoreIds) {
                sources.knowledgeStoreIds = {};
            }
            sources.knowledgeStoreIds[gyanId] = {};
        }
        this.mksFlag ? this.updateRepoIds(sources, gyanId, ischecked) : this.updateKnowledgeStoreIds(sources, gyanId, ischecked);

        localStorage.setItem('sources', JSON.stringify(sources));
        this.sendCheckedListGKS.emit();
    }

    getSourcesFromLocalStorage() {
        const localStorageKey = 'sources';
        return localStorage.getItem(localStorageKey)
            ? JSON.parse(localStorage.getItem(localStorageKey)!)
            : {
                  repoIds: {},
                  repoAvailable: false,
                  knowledgeStoreIds: {},
                  webAvailable: false,
                  favouriteWebsites: [],
                  dispreferredWebsites: [],
                  includeSubTopic: {},
              };
    }

    updateTopicOutlineSources(gyanId: string, ischecked: boolean) {
        const topicOutline = this.getTopicOutlineFromLocalStorage();
        this.processOutline(topicOutline, gyanId, ischecked, this.topic.id);
        localStorage.setItem('topicOutline', JSON.stringify(topicOutline));
    }

    getTopicOutlineFromLocalStorage() {
        const localStorageKey = 'topicOutline';
        return localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)!) : this.topicOutline;
    }

    processOutline(outline: any, gyanId: string, ischecked: boolean, currentTopicId: number) {
        if (outline.id === currentTopicId) {
            this.mksFlag ? this.updateRepoIds(outline.sourcesSubTopic, gyanId, ischecked) : this.updateKnowledgeStoreIds(outline.sourcesSubTopic, gyanId, ischecked);
        } else if (outline.subtopics && outline.subtopics.length > 0) {
            outline.subtopics.forEach((subtopic: any) => this.processOutline(subtopic, gyanId, ischecked, currentTopicId));
        }
    }

    updateRepoIds(sourceObject: any, gyanId: string, ischecked: boolean) {
        if (ischecked && sourceObject.repoIds[gyanId] == undefined) {
            sourceObject.repoIds[gyanId] = {};
        } else if (JSON.stringify(sourceObject.repoIds[gyanId]) == '{}') {
            if (ischecked && Object.values(sourceObject.repoIds[gyanId]).length == 0) {
                sourceObject.repoIds[gyanId] = {};
            } else {
                delete sourceObject.repoIds[gyanId];
                delete sourceObject.knowledgeStoreIds[gyanId];
            }
        }
    }

    updateKnowledgeStoreIds(sourceObject: any, gyanId: string, ischecked: boolean) {
        if (ischecked && sourceObject.knowledgeStoreIds[gyanId] == undefined) {
            sourceObject.knowledgeStoreIds[gyanId] = {};
        } else if (JSON.stringify(sourceObject.knowledgeStoreIds[gyanId]) == '{}') {
            if (ischecked && Object.values(sourceObject.knowledgeStoreIds[gyanId]).length == 0) {
                sourceObject.knowledgeStoreIds[gyanId] = {};
            } else {
                delete sourceObject.knowledgeStoreIds[gyanId];
            }
        }
    }

    // getCheckedItemList() {
    //     this.checkedListGKS = this.gksLibrary.filter((itm: any) => itm.checked === true);
    //     this.sendCheckedListGKS.emit(this.checkedListGKS); //sending to parent submit component
    // }

    initializeForm(formData: any = null): void {
        const fieldsArray = formData ? formData.fields.map((field: any) => this.addFormField(field)) : [this.addFormField()];
        this.form = this.fb.group({
            fields: this.fb.array(fieldsArray),
            isIncludeSubtopic: [true],
        });
    }

    showPopup(gyanKnowledgeStore: any, content: any): void {
        this.mksFlag = gyanKnowledgeStore.siteName !== '' ? true : false;
        console.log(gyanKnowledgeStore);
        console.log(content);
        this.selectedGyanKnowledgeStore = gyanKnowledgeStore;
        gyanKnowledgeStore.checked = true;

        this.updateSourcesWithCheckbox(gyanKnowledgeStore.id, gyanKnowledgeStore.checked);
        if (this.gksLevel == 'topicLevel') {
            this.IncludeSubtopic(gyanKnowledgeStore.id, true, false);
        }
        const localStorageKey = 'gyanKnowledgeStore';
        const localStorageData = localStorage.getItem(localStorageKey);

        const localStorageKeyGK = 'subtopicSource_gyanKnowledgeStore';
        const localStorageDataGK = localStorage.getItem(localStorageKeyGK);
        const parsedDataGK = localStorageDataGK ? JSON.parse(localStorageDataGK) : null;
        //  console.log(localStorage.getItem(localStorageKey));
        this.isLoadingTags = false;
        if (localStorageData && this.gksLevel == 'gyanLevel') {
            // Load data from local storage
            this.loadDataFromLocalStorage(localStorageData, gyanKnowledgeStore);
        } else if (this.topic !== undefined && parsedDataGK && parsedDataGK[this.topic.id] && this.gksLevel == 'topicLevel') {
            this.loadDataFromLocalStorage(localStorageDataGK, gyanKnowledgeStore);
        } else {
            //this.getTags(myKnowledgeStore.uuid)
            this.callAPIGetKnowledgeStoreTags(gyanKnowledgeStore.id, gyanKnowledgeStore.siteName);
        }

        console.log('show popup', gyanKnowledgeStore);
        this.modalRef = this.modalService.open(content, { size: 'lg' });
    }

    loadDataFromLocalStorage(localStorageData: any, gyanKnowledgeStore: any): void {
        if (localStorageData) {
            const parsedData = JSON.parse(localStorageData);
            console.log(parsedData);
            if (parsedData[gyanKnowledgeStore.id] && this.gksLevel == 'gyanLevel') {
                this.apiResponse = parsedData[gyanKnowledgeStore.id].apiResponse;
                console.log(this.apiResponse);
                this.initializeForm(parsedData[gyanKnowledgeStore.id].formData);
                this.isLoadingTags = true;
            } else if (this.topic?.id && parsedData[this.topic?.id] && this.gksLevel == 'topicLevel') {
                if (this.mksFlag && parsedData[this.topic.id][gyanKnowledgeStore.id] == undefined) {
                    this.callAPIGetKnowledgeStoreTags(gyanKnowledgeStore.id, gyanKnowledgeStore.siteName);
                } else {
                    if (parsedData[this.topic.id][gyanKnowledgeStore.id] == undefined) {
                        this.callAPIGetKnowledgeStoreTags(gyanKnowledgeStore.id, gyanKnowledgeStore.siteName);
                        return;
                    }
                    this.apiResponse = parsedData[this.topic.id][gyanKnowledgeStore.id].apiResponse;
                    console.log(this.apiResponse);
                    this.initializeForm(parsedData[this.topic.id][gyanKnowledgeStore.id].formData);
                    this.isLoadingTags = true;
                    //this.isIncludeSubtopic = this.topic.sourcesSubTopic.includeSubTopic[gyanKnowledgeStore.id]
                    const includeSubTopic = this.topic.sourcesSubTopic.includeSubTopic;
                    this.form.patchValue({
                        isIncludeSubtopic: includeSubTopic[this.selectedGyanKnowledgeStore.id], // Set to true or false as needed
                    });
                }
            } else {
                //this.initializeForm(); // Initialize an empty form if no data found
                this.callAPIGetKnowledgeStoreTags(gyanKnowledgeStore.id, gyanKnowledgeStore.siteName);
            }
        } else {
            this.initializeForm(); // Initialize an empty form if no data found
        }
    }

    callAPIGetKnowledgeStoreTags(id: string, siteName: string) {
        console.log('callAPIGetKnowledgeStoreTags', id, siteName);
        if (siteName !== '') {
            const siteName = this.getSiteNameByID(id);
            if (siteName) {
                this.submitgyanService.getRepoTags(siteName).subscribe({
                    next: (response) => {
                        console.log('this.apiResponse: ', response);
                        this.apiResponse = response;
                        this.initializeForm();
                        this.isLoadingTags = true;
                    },
                    error: (error) => {
                        console.error('Error fetching repo tags:', error);
                    },
                });
            } else {
                console.warn(`No siteName found for ID: ${id}`);
            }
        } else {
            this.submitgyanService.getKnowledgeStoreTags(id).subscribe((response) => {
                console.log(response);
                this.apiResponse = response.tags;
                this.initializeForm();
                //this.saveApiResponseToLocalStorage(gyanKnowledgeStore.id, response);
                this.isLoadingTags = true;
            });
        }
    }

    getSiteNameByID(id: string): string | undefined {
        // console.log("environment.type",environment.type);
        const envData = this.mksMITOCWData.find((item) => item.env === environment.type);
        console.log(envData);
        if (envData) {
            const siteData = envData.data.find((item) => item.id === id);
            return siteData ? siteData.siteName : '';
        }
        return '';
    }

    get fields(): FormArray {
        return this.form.get('fields') as FormArray;
    }

    apiResponseKeys(): Array<any> {
        //console.log('this.apiResponse', this.apiResponse ? this.apiResponse.map((tag: any) => tag) : []);
        return this.apiResponse ? this.apiResponse.map((tag: any) => tag) : [];
    }

    apiResponseKeysMKS(): Array<{ id: string; tagName: string; idWithoutSite: string }> {
        return this.apiResponse
            ? this.apiResponse.map((tag: any) => ({
                  id: tag.id,
                  tagName: tag.tagName,
                  idWithoutSite: tag.idWithoutSite,
                  dataType: tag.dataType,
              }))
            : [];
    }
    compareTags(tag1: any, tag2: any): boolean {
        return tag1 && tag2 ? tag1.id === tag2.id : tag1 === tag2;
    }
    isKeyDisabled(key: string) {
        return this.fields.controls.some((control) => control.get('key')?.value === key);
    }

    isKeyDisabledMKS(idWithoutSite: string): boolean {
        return this.fields.controls.some((control) => control.get('key')?.value?.idWithoutSite === idWithoutSite);
    }

    onDateFromChange(event: any): void {
        const selectedDate = event.target.value;
        this.minDateTo = selectedDate;
    }

    onDateToChange(event: any): void {
        const selectedDate = event.target.value;
        this.maxDateFrom = selectedDate;
    }

    addFormField(fieldData: any = null): FormGroup {
        console.log('Adding field with data:', fieldData);
        const fieldGroup = this.fb.group({
            key: [fieldData ? fieldData.key : '', Validators.required],
            tagValues: [fieldData ? fieldData.tagValues : ''], // Updated to support array for multiple values
            dataType: [fieldData ? fieldData.dataType : ''],
            dateFieldFrom: [fieldData ? fieldData.dateFieldFrom : ''],
            dateFieldTo: [fieldData ? fieldData.dateFieldTo : ''],
            optionCtrl: [fieldData ? fieldData.optionCtrl : ''], // Separate option control for each field
            filteredOptions: [fieldData ? fieldData.filteredOptions : []], // Initialize empty filteredOptions
            showDropdown: [fieldData ? fieldData.showDropdown : false], // Track dropdown visibility for each field
            selectedOptions: [fieldData ? fieldData.selectedOptions : []], // Store selected options for each field
            id: [fieldData ? fieldData.id : ''],
        });
        // If key is already selected, disable the select box
        if (fieldData && fieldData.key) {
            fieldGroup.get('key')?.disable();
        }
        return fieldGroup;
    }

    removeFormField(index: number): void {
        this.removedFieldKey = this.fields.at(index).get('key')?.value; // Store the removed field key

        this.fields.removeAt(index);
        if (this.fields.length === 0) {
            this.fields.push(this.addFormField());
        } else if (this.fields.length < Object.keys(this.apiResponse).length) {
            // Ensure only one new empty field is always present
            while (this.fields.length < Object.keys(this.apiResponse).length && this.fields.controls.some((control) => control.get('key')?.value === '')) {
                this.fields.removeAt(this.fields.length - 1);
            }
            this.fields.push(this.addFormField());
        }
    }

    shouldShowDeleteButton(index: number): boolean {
        return !!this.fields.at(index).get('key')?.value;
    }

    getOptionCtrl(index: number): FormControl | null {
        const control = this.fields.at(index).get('optionCtrl');
        return control instanceof FormControl ? control : null;
    }

    // filtering options on the input, excluding the selected options
    filterOptions(index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        // Get the value of the selected tag name (from the 'key' control)
        const selectedTag = this.mksFlag ? fieldGroup.get('key')?.value?.idWithoutSite : fieldGroup.get('key')?.value;
        //console.log('Selected tag:', selectedTag);

        //console.log(fieldGroup.get('optionCtrl'));
        const query = fieldGroup.get('optionCtrl')?.value || '';

        if (query === '') {
            fieldGroup.patchValue({
                showDropdown: false, // Always show the dropdown
            });
        }

        // Calling api after typing
        if (query && query.length > 1) {
            console.log(this.mksFlag);
            if (this.mksFlag) {
                this.callApiAndFilterOptionsMKS(query, selectedTag, index);
            } else {
                this.callApiAndFilterOptions(query, selectedTag, index);
            }
        } else {
            // Clear filtered options if the input is empty
            fieldGroup.patchValue({ filteredOptions: [] });
        }
    }
    callApiAndFilterOptionsMKS(query: string, selectedTag: string, index: number): void {
        console.log(this.selectedGyanKnowledgeStore);
        // Replace with your API call logic
        this.submitgyanService.getSolrData(this.selectedGyanKnowledgeStore.id, selectedTag, query.toLowerCase()).subscribe({
            next: (response: any) => {
                const data = response.response.docs;
                // preparing all options from the API response
                const allOptions = Array.from(
                    new Set(
                        data.reduce((acc: any, item: any) => {
                            const value = Object.values(item)[0];
                            if (Array.isArray(value)) {
                                acc = acc.concat(value); // Concatenate array values
                            } else {
                                acc.push(value); // Add single values
                            }
                            return acc;
                        }, []),
                    ),
                );

                console.log(allOptions);
                // get selected options for this form group
                const fieldGroup = this.fields.at(index) as FormGroup;
                const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

                // removing previously selected options
                const filteredOptions = allOptions.filter((option) => !selectedOptions.includes(option));

                // checking if no options are left after filtering
                if (allOptions.length === 0) {
                    // showing "No result found"
                    fieldGroup.patchValue({
                        filteredOptions: [],
                        showDropdown: true,
                    });
                } else {
                    // updating filtered options
                    fieldGroup.patchValue({
                        filteredOptions: filteredOptions,
                        showDropdown: filteredOptions.length > 0, //true
                    });
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);

                // if error then the dropdown shows "No result found"
                const fieldGroup = this.fields.at(index) as FormGroup;
                fieldGroup.patchValue({
                    filteredOptions: [],
                    showDropdown: true, // Ensure the dropdown is shown even on error
                });
            },
        });
    }

    callApiAndFilterOptions(query: string, selectedTag: string, index: number): void {
        // Replace with your API call logic
        this.submitgyanService.getSolrDataGKS(this.selectedGyanKnowledgeStore.name.toLowerCase(), selectedTag, query.toLowerCase()).subscribe({
            next: (response: any) => {
                const data = response.response.docs;
                // preparing all options from the API response
                const allOptions = Array.from(
                    new Set(
                        data.reduce((acc: any, item: any) => {
                            const value = Object.values(item)[0];
                            if (Array.isArray(value)) {
                                acc = acc.concat(value); // Concatenate array values
                            } else {
                                acc.push(value); // Add single values
                            }
                            return acc;
                        }, []),
                    ),
                );

                console.log(allOptions);
                // get selected options for this form group
                const fieldGroup = this.fields.at(index) as FormGroup;
                const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

                // removing previously selected options
                const filteredOptions = allOptions.filter((option) => !selectedOptions.includes(option));

                // checking if no options are left after filtering
                if (allOptions.length === 0) {
                    // showing "No result found"
                    fieldGroup.patchValue({
                        filteredOptions: [],
                        showDropdown: true,
                    });
                } else {
                    // updating filtered options
                    fieldGroup.patchValue({
                        filteredOptions: filteredOptions,
                        showDropdown: filteredOptions.length > 0,
                    });
                }
            },
            error: (error: HttpErrorResponse) => {
                console.log('Error: ', error.message);

                // if error then the dropdown shows "No result found"
                const fieldGroup = this.fields.at(index) as FormGroup;
                fieldGroup.patchValue({
                    filteredOptions: [],
                    showDropdown: true, // Ensure the dropdown is shown even on error
                });
            },
        });
    }

    // showing selected options
    selectOption(option: string, index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];

        if (!selectedOptions.includes(option)) {
            selectedOptions.push(option);
        }

        const allOptions = fieldGroup.get('filteredOptions')?.value || [];
        const filteredOptions = allOptions.filter((opt: any) => !selectedOptions.includes(opt));

        // Update the selected options and close the dropdown
        fieldGroup.patchValue({
            selectedOptions: selectedOptions,
            optionCtrl: '', // clear input after selecting an option
            filteredOptions: filteredOptions, // Update the filtered options
            showDropdown: fieldGroup.get('filteredOptions')?.value.length > 0, // close dropdown // false
        });
    }

    // removing selected option
    remove(option: string, index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const selectedOptions = fieldGroup.get('selectedOptions')?.value || [];
        const updatedOptions = selectedOptions.filter((selected: string) => selected !== option);

        fieldGroup.patchValue({
            selectedOptions: updatedOptions,
        });

        this.filterOptions(index);
    }

    // close dropdown when clicking outside
    @HostListener('document:click', ['$event'])
    clickout(event: Event): void {
        const targetElement = event.target as HTMLElement;

        this.fields.controls.forEach((control, index) => {
            const fieldGroup = control as FormGroup;
            const optionCtrl = fieldGroup.get('optionCtrl') as FormControl;

            // checking if the click is outside of the current input field or dropdown
            if (!this.eRef.nativeElement.contains(targetElement)) {
                optionCtrl.setValue(''); // clearing input
                fieldGroup.patchValue({ showDropdown: false }); // closing dropdown
            }
        });
    }

    // when user start typing then only show dropdown
    onFocus(index: number): void {
        const optionCtrlValue = this.fields.at(index).get('optionCtrl')?.value;
        const fieldGroup = this.fields.at(index) as FormGroup;

        if (optionCtrlValue) {
            ///  showing dropdown if input has value
            fieldGroup.patchValue({ showDropdown: true });
            this.filterOptions(index);
        }
    }

    // showing dropdown when focus on input
    onInputFocus(index: number): void {
        const optionCtrlValue = this.fields.at(index).get('optionCtrl')?.value;
        const fieldGroup = this.fields.at(index) as FormGroup;

        if (optionCtrlValue) {
            //  showing dropdown if input has value
            fieldGroup.patchValue({ showDropdown: true });
        }
    }

    // showing title for +count bades
    getHiddenOptionsTitle(selectedOptions: Array<string>): string {
        const hiddenOptions = selectedOptions.slice(this.maxVisibleBadges);
        return hiddenOptions.join(', ');
    }

    // removing by pressing backspace in an empty input
    removeLastSelected(index: number): void {
        const fieldGroup = this.fields.at(index) as FormGroup;
        const optionCtrlValue = fieldGroup.get('optionCtrl')?.value;

        if (!optionCtrlValue && fieldGroup.get('selectedOptions')?.value.length > 0) {
            const selectedOptions = fieldGroup.get('selectedOptions')?.value;
            selectedOptions.pop();

            fieldGroup.patchValue({
                selectedOptions: selectedOptions,
            });

            this.filterOptions(index);
        }
    }

    onKeyChange(index: number) {
        if (this.mksFlag) {
            const selectedKey = this.fields.at(index).get('key')?.value;
            console.log(selectedKey);
            const selectedTag = this.apiResponse.find((tag: { idWithoutSite: any }) => tag.idWithoutSite === selectedKey.idWithoutSite);
            console.log(selectedTag);
            if (!selectedTag) return;
            const fieldGroup = this.fields.at(index) as FormGroup;
            const selectedTagID = selectedTag.id;
            //   const isMultiValue = selectedTag.isMultiValue
            const dataType = selectedTag.dataType;
            fieldGroup.patchValue({
                key: selectedKey,
                value: '', //dataType === 'text' ? '' : '',
                dataType: dataType,
                dateFieldFrom: '',
                dateFieldTo: '',
                id: selectedTagID,
            });
            //fieldGroup.get('key')?.disable();
            setTimeout(() => {
                fieldGroup.get('key')?.disable();
            }, 10);
            // Add new field if there are remaining values and fields length is less than API response keys
            if (this.fields.length < Object.keys(this.apiResponse).length) {
                //remainingValues.length > 0 &&
                this.fields.push(this.addFormField());
            }
            return;
        }
        const selectedKey = this.fields.at(index).get('key')?.value;
        console.log(selectedKey);
        const selectedTag = this.apiResponse.filter((tag: any) => tag.tagName === selectedKey);
        const fieldGroup = this.fields.at(index) as FormGroup;
        const dataType = selectedTag[0].dataType;
        console.log(dataType);

        fieldGroup.patchValue({
            key: selectedKey,
            tagValues: dataType === 'Text' ? '' : [],
            dataType: dataType,
            dateFieldFrom: '',
            dateFieldTo: '',
        });
        fieldGroup.get('key')?.disable();

        console.log(this.apiResponse[selectedKey]);

        // Add new field if there are remaining values and fields length is less than API response keys
        // if (remainingValues.length > 0 && this.fields.length < Object.keys(this.apiResponse).length) {
        //     this.fields.push(this.addFormField());
        // }

        if (this.fields.length < this.apiResponse.length) {
            console.log('adding new field');
            this.fields.push(this.addFormField());
        } else {
            console.log('No new field');
        }
    }

    saveFormToLocalStorage(uuid: string): void {
        const localStorageKey = 'gyanKnowledgeStore';
        const localStorageKeyGK = 'subtopicSource_gyanKnowledgeStore';
        const formData = this.getEnabledFormData();

        const errorMessages: Array<string> = [];

        // checking for empty selectedOptions and invalid date fields
        formData.fields.forEach((field: any) => {
            const dataType = field.dataType || '';

            if (dataType) {
                // Check if selectedOptions is empty for "Text" or "text" data type
                if ((dataType === 'Text' || dataType.toLowerCase() === 'text') && field.selectedOptions.length === 0) {
                    errorMessages.push(`Please select at least one tag for "${field.key}" before saving.`);
                }

                // Check for empty date fields for "Date", "date", or "datetime" data types
                if ((dataType === 'Date' || dataType.toLowerCase() === 'date' || dataType.toLowerCase() === 'datetime') && (!field.dateFieldFrom || !field.dateFieldTo)) {
                    errorMessages.push(`Please enter both dates for "${field.key}".`);
                }
            }
        });

        // if error then showing toast
        if (errorMessages.length > 0) {
            this.toastr.warning(errorMessages.join(' '), 'Validation Error');
            return;
        }

        //selectOptions can be stored as comma separated in values
        formData.fields.forEach((field: any) => {
            // Check if selectedOptions has values
            if (field.selectedOptions && field.selectedOptions.length > 0) {
                // Store the selectedOptions as a comma-separated string in value
                field.tagValues = field.selectedOptions.join(', ');
            }
        });

        const dataToSave = {
            apiResponse: this.apiResponse,
            formData: formData,
        };

        if (this.gksLevel == 'gyanLevel') {
            const knowledgeStore = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)!) : {};
            knowledgeStore[uuid] = dataToSave;
            localStorage.setItem(localStorageKey, JSON.stringify(knowledgeStore));
            this.saveTransformedDataToLocalStorage();
        } else {
            const knowledgeStore = localStorage.getItem(localStorageKeyGK) ? JSON.parse(localStorage.getItem(localStorageKeyGK)!) : {};

            if (!knowledgeStore[this.topic.id]) {
                knowledgeStore[this.topic.id] = {};
            }
            knowledgeStore[this.topic.id][uuid] = dataToSave;
            localStorage.setItem(localStorageKeyGK, JSON.stringify(knowledgeStore));
            this.IncludeSubtopic(uuid, false, false);
        }

        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    // Method to convert date to ISO format
    convertToISO(date: Date): string {
        return date.toISOString();
    }

    saveTransformedDataToLocalStorage(): void {
        const localStorageKey = 'sources';
        const knowledgeStoreKey = 'gyanKnowledgeStore';
        const transformedData = localStorage.getItem(localStorageKey)
            ? JSON.parse(localStorage.getItem(localStorageKey)!)
            : {
                  repoIds: {},
                  repoAvailable: false,
                  knowledgeStoreIds: {},
                  webAvailable: false,
                  favouriteWebsites: [],
                  dispreferredWebsites: [],
                  includeSubTopic: {},
              };

        const knowledgeStoreData = localStorage.getItem(knowledgeStoreKey);
        if (!knowledgeStoreData) {
            console.log('No knowledgeStore data found.');
            return;
        }

        const parsedKnowledgeStore = JSON.parse(knowledgeStoreData);
        // Loop over each UUID in the knowledgeStore data
        for (const uuid in parsedKnowledgeStore) {
            if (parsedKnowledgeStore.hasOwnProperty(uuid)) {
                const gksIds = uuid;
                const formData = parsedKnowledgeStore[uuid].formData;

                // Filter out the removed field from formData, if any
                if (this.removedFieldKey) {
                    formData.fields = formData.fields.filter((field: any) => field.key !== this.removedFieldKey);
                    console.log(formData.fields);
                    parsedKnowledgeStore[uuid].formData = formData;
                }

                formData.fields.forEach((field: any) => {
                    const fieldKey = this.mksFlag ? field.id : field.key;
                    const dataType = field.dataType;
                    let values: any = [];
                    // text splitting string into an array
                    if (dataType === 'Text' || dataType === 'text') {
                        const rawValues = field.tagValues || '';
                        values = typeof rawValues === 'string' ? rawValues.split(',').map((value: string) => value.trim()) : rawValues;
                    }
                    // Date type by storing dateFieldFrom and dateFieldTo as an array
                    if (dataType === 'Date' || dataType === 'date' || dataType === 'datetime') {
                        values = [this.convertToISO(new Date(field.dateFieldFrom)), this.convertToISO(new Date(field.dateFieldTo))];
                    }
                    // Initialize the entry in the selected data structure if it doesn't exist
                    if (typeof fieldKey === 'string' && fieldKey && values && values.length > 0 && values.some((value: any) => value)) {
                        const targetIds = this.mksFlag ? 'repoIds' : 'knowledgeStoreIds';

                        if (!transformedData[targetIds][gksIds]) {
                            transformedData[targetIds][gksIds] = {};
                        }

                        if (!transformedData[targetIds][gksIds][fieldKey]) {
                            transformedData[targetIds][gksIds][fieldKey] = {
                                DT: dataType,
                                V: [],
                            };
                        }

                        // Merge and avoid duplicates
                        transformedData[targetIds][gksIds][fieldKey].V = [...new Set([...transformedData[targetIds][gksIds][fieldKey].V, ...values])];
                    }
                });

                // Remove the field from sources if a field was removed
                const targetIds = this.mksFlag ? 'repoIds' : 'knowledgeStoreIds';
                if (this.removedFieldKey && transformedData[targetIds][gksIds]) {
                    delete transformedData[targetIds][gksIds][this.removedFieldKey];
                }
            }
        }

        //  save to sources in localstorage
        localStorage.setItem(localStorageKey, JSON.stringify(transformedData));
        localStorage.setItem(knowledgeStoreKey, JSON.stringify(parsedKnowledgeStore));
        // Reset the removedFieldKey after the cleanup is done
        this.removedFieldKey = null;
    }
    IncludeSubtopic(id: string, fromAutoCheck: boolean, removeChecked: boolean) {
        const isChecked = fromAutoCheck ? true : this.form.get('isIncludeSubtopic')?.value;
        const localStorageKey_topicOutline = 'topicOutline';
        const topicOutline = localStorage.getItem(localStorageKey_topicOutline) ? JSON.parse(localStorage.getItem(localStorageKey_topicOutline)!) : this.topicOutline;

        function updateIncludeSubtopic(topicOutline: any, gksLevel: string, isChecked: boolean, gyanId: string, currentTopicId: number) {
            function handleTopicLevel(outline: any) {
                const includeSubTopic = outline.sourcesSubTopic.includeSubTopic;
                if (gyanId !== undefined && gyanId !== null) {
                    if (isChecked) {
                        includeSubTopic[gyanId] = true;
                    } else {
                        includeSubTopic[gyanId] = false;
                    }
                }

                if (removeChecked) delete includeSubTopic[gyanId];

                console.log(includeSubTopic);
            }

            function processOutline(outline: any) {
                // Check if the current outline's ID matches the current topic ID
                if (outline.id === currentTopicId && gksLevel === 'topicLevel') {
                    handleTopicLevel(outline);
                } else if (outline.subtopics && outline.subtopics.length > 0) {
                    // Continue the search in nested subtopics if the ID doesn't match
                    outline.subtopics.forEach((subtopic: any) => processOutline(subtopic));
                }
            }

            // Start processing from the root topicOutline
            processOutline(topicOutline);
        }

        updateIncludeSubtopic(topicOutline, this.gksLevel, isChecked, id, this.topic.id);
        localStorage.setItem(localStorageKey_topicOutline, JSON.stringify(topicOutline));
    }
    getEnabledFormData(): any {
        // Enable all 'key' f ields temporarily
        this.fields.controls.forEach((fieldGroup) => {
            fieldGroup.get('key')?.enable();
        });

        const formData = this.form.getRawValue();

        // Disable the 'key' fields again
        this.fields.controls.forEach((fieldGroup) => {
            if (fieldGroup.get('key')?.value) {
                fieldGroup.get('key')?.disable();
            }
        });
        return formData;
    }

    trackByFn(index: number, item: any): number {
        return index; // or return a unique identifier for each item
    }

    checkWidth() {
        const width = window.innerWidth;
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    ngOnDestroy() {
        if (this.getTemplateSubsSources) this.getTemplateSubsSources.unsubscribe();

        if (this.getTemplateSourcesSubTopics) this.getTemplateSourcesSubTopics.unsubscribe();

        if (this.templateLoaded) this.templateLoaded.unsubscribe();
    }
}
